import Axios from "axios";
import { takeLatest, put, call } from 'redux-saga/effects';
import {
    GET_SCORECARD_LIST,
    getScoreCardListSuccess,
    getScoreCardListFailure
} from './actions';
import { REPORT } from '../../../config';
const token = localStorage.getItem('id_token');
const httpHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Bearer ${token}`
};
export function* scoreCardList(action) {
    let requestURL = `${REPORT}/computedscorecard/list`;
    try {
        const result = yield call(Axios.get, requestURL, { headers: httpHeaders });
        yield put(getScoreCardListSuccess(result.data));
    } catch (err) {
        yield put(getScoreCardListFailure(err))
    }
}
export function* getScorecardList() {
    yield takeLatest(GET_SCORECARD_LIST, scoreCardList);
}